export default "__VITE_ASSET__a903f3ee__"